import { createFileRoute } from '@tanstack/react-router'
import {UrgentCareAppointmentsPage} from '~/features/dashboard/pages/urgent-care/appointments'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/urgent-care/appointments/',
)({
  component: RouteComponent,
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
 <h1 className="text-2xl font-bold">Error Loading Encounters</h1>
         <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),

})

function RouteComponent() {
  return <main role="main" aria-label="weight loss content" className="min-h-screen w-full"><UrgentCareAppointmentsPage /></main>
}
